import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import router from './router/index.js'
import store from './store/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import globalcomponents from './plugin/globalcomponents.js'
import md5 from 'js-md5';
import './../static/css/hpDefault.css'
import './assets/icon/iconfont.css'
import Print from './plugin/print'
import WaterMark from 'vue-watermark'

Vue.use(ElementUI)
Vue.use(globalcomponents)
Vue.use(Print)
Vue.component('WaterMark', WaterMark)
//require('./mock/index');

Vue.prototype.$axios = Axios
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false


/***********定义拦截器**********/
// http request 拦截器
var loadinginstace
// 超时时间
Axios.defaults.timeout = 300000
// Axios.defaults.withCredentials=true;//带有cookie
// Axios.defaults.emulateJSON=true;
Axios.defaults.headers = {"Content-Type": "application/x-www-form-urlencoded"}
Axios.interceptors.request.use(
    config => {
      if (!config.noloading) {
        loadinginstace = ElementUI.Loading.service({
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)',
          text: '加载中'
        })
      }
      var Token = localStorage.getItem("hpapi_token");
      if (router.currentRoute.meta && router.currentRoute.meta.requiresWebAuth) {
        Token = localStorage.getItem("hpweb_token");
      }
      if (config.ssotoken) {
        Token = config.ssotoken;
      }
      if (config.authorization) {
        config.headers.Authorization = "Bearer " + config.authorization;
      } else if (Token) {
        config.headers.appguid = localStorage.getItem("appguid")
        config.headers.token = Token
        config.headers.timestamp = new Date().getTime()
        config.headers.deviceid = ""
        config.headers.os = ""
        config.headers.sign = md5(config.headers.deviceid + config.headers.timestamp + config.headers.token)
      }
      return config;
    },
    err => {
        if (loadinginstace) {
            loadinginstace.close()
        }
        ElementUI.Message.error({
            message: '加载超时'
        })
        return Promise.reject(err);
    });

// http response 拦截器
Axios.interceptors.response.use(
    response => {
        // 只有非noloading请求才关闭loading，避免noloading请求响应抢先关闭主请求的loading
        if (loadinginstace && !response.config.noloading) {
            loadinginstace.close()
            loadinginstace = null
        }
        switch (response.data.code) {
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                localStorage.removeItem("hpapi_token")
                router.replace({
                    name: 'login',
                    parames: {redirect: router.currentRoute.fullPath}
                })
                ElementUI.Message.error({
                    message: response.data.msg
                })
                return;
            case 402://无权限
                ElementUI.Message.error({
                    message: response.data.msg
                })
                return;
        }
        return response;
    },
    error => {
        if (loadinginstace) {
            loadinginstace.close()
            loadinginstace = null
        }
        return
        // if (error.response) {
        //   switch (error.response.status) {
        //     case 401:
        //       // 返回 401 清除token信息并跳转到登录页面
        //       localStorage.removeItem("token")
        //       router.replace({
        //         name: 'login',
        //         parames: {redirect: router.currentRoute.fullPath}
        //       })
        //   }
        // }
        //return Promise.reject(error.response.data)   // 返回接口返回的错误信息
    });
/**********拦截器结束************/

Vue.directive('focus', function (el, option) {
    var defClass = 'el-input', defTag = 'input';
    var value = option.value || true;
    if (typeof value === 'boolean')
        value = {cls: defClass, tag: defTag, foc: value};
    else
        value = {cls: value.cls || defClass, tag: value.tag || defTag, foc: value.foc || false};
    if (el.classList.contains(value.cls) && value.foc)
        el.getElementsByTagName(value.tag)[0].focus();
});

Vue.prototype.tableHeight = function (cutHeight, searchH, footH) {
    var cutH = (cutHeight || 79);
    if (this.$route.query.token) {
        cutH -= 48;
    }
    return document.documentElement.clientHeight - (footH || 32) - (searchH || 60) - cutH;
}
Vue.prototype.dialogtableHeight = function (cutHeight, searchH, footH) {
    return document.documentElement.clientHeight - (footH || 32) - (searchH || 60) - (cutHeight || 79);
}
Vue.prototype.pageSize = function () {
    return 20;
}

/* eslint-disable no-new */
var vm=new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js